import { FC, useCallback } from "react";
import { Typography } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import {
  useDeleteUsersMeCategoriesByCategoryIdMutation,
  useGetUsersMeCategoriesQuery,
} from "../../../../../../services/cloudchipr.api";
import { DeleteConfirmationDialog } from "../../../../../common/modals/DeleteConfirmationDialog";

interface DeleteCategoryConfirmDialogProps {
  open: boolean;
  categoryId: string;
  name: string;
  onClose(): void;
}

export const DeleteCategoryConfirmDialog: FC<
  DeleteCategoryConfirmDialogProps
> = ({ categoryId, onClose, open, name }) => {
  const [trigger, { isLoading }] =
    useDeleteUsersMeCategoriesByCategoryIdMutation();
  const { refetch } = useGetUsersMeCategoriesQuery();

  const deleteHandler = useCallback(async () => {
    await trigger({ categoryId });
    await refetch();

    onClose();

    enqueueSnackbar("Category successfully deleted.", {
      variant: "snackbarAlert",
      AlertSnackBarProps: { severity: "success" },
    });
  }, [categoryId, onClose, trigger, refetch]);

  return (
    <DeleteConfirmationDialog
      open={open}
      title="Delete Category?"
      onClose={onClose}
      onDelete={deleteHandler}
      loading={isLoading}
      content={
        <Typography color="text.secondary" variant="subtitle1">
          Are you sure you want to delete category
          <Typography component="span" fontWeight="bold">
            {` ${name} `}
          </Typography>
          ?
        </Typography>
      }
    />
  );
};
